import React, {
    useEffect,
    useState
} from "react";

import {
    doc,
    collection,
    onSnapshot,
    addDoc,
    setDoc,
    updateDoc,
    deleteDoc,
    increment,
    serverTimestamp,
    runTransaction
} from "../../access/firestore";

import { db, storage } from "../../firebase";
import {
    ref,
    uploadBytes,
    getDownloadURL,
    deleteObject
} from "firebase/storage";
import { useClinic } from "../../context/ClinicContext";
import { requestVexaConfirm } from "../../notifications/dialogService";

import {

    FileText,
    Plus,
    DollarSign,
    FileDown,
    MessageCircle,
    Lock,
    Eye,
    Download,
    Presentation,
    ChevronDown,
    ChevronUp,
    Trash2
} from "lucide-react";
import Odontograma from "../../Odontograma";

import {
    DndContext,
    closestCenter
} from "@dnd-kit/core";

import {
    SortableContext,
    verticalListSortingStrategy
} from "@dnd-kit/sortable";

import SignatureCanvas from "react-signature-canvas";

import { jsPDF } from "jspdf";

import {
    sendWhatsAppFileVPS
} from "../../services/whatsappVPS";

export default function PlanTratamientoPanel({

    paciente

}) {

    const { clinicId, clinicData } = useClinic();

    const [procedures, setProcedures] = useState([]);

    const [planes, setPlanes] = useState([]);

    const [filtroEstado, setFiltroEstado] = useState("Todos");

    const [buscarPlan, setBuscarPlan] = useState("");

    const [planExpandido, setPlanExpandido] = useState(null);

    const [procedureSearch, setProcedureSearch] = useState({});

    const [showSignature, setShowSignature] =
        useState(null);

    const [signaturePad, setSignaturePad] =
        useState(null);

        const planesFiltrados = planes.filter(plan => {

            const coincideBusqueda =

                (plan.nombre || "")
                    .toLowerCase()
                    .includes(
                        buscarPlan.toLowerCase()
                    );

            const coincideEstado =

                filtroEstado === "Todos"

                    ? true

                    : plan.estado === filtroEstado;

            return coincideBusqueda && coincideEstado;

        });

    useEffect(() => {

        if (!clinicId) return;

        const unsubscribe = onSnapshot(

            doc(
                db,
                "clinics",
                clinicId,
                "settings",
                "procedures"
            ),

            (snap) => {

                if (!snap.exists()) {

                    setProcedures([]);
                    return;

                }

                setProcedures(
                    snap.data().data || []
                );

            }

        );

        return () => unsubscribe();

    }, [clinicId]);

    useEffect(() => {

        if (!clinicId || !paciente?.id) return;

        const unsubscribe = onSnapshot(

            collection(

                db,

                "clinics",

                clinicId,

                "pacientes",

                paciente.id,

                "planesTratamiento"

            ),

            (snap) => {

                const data = snap.docs.map(doc => ({

                    id: doc.id,

                    ...doc.data()

                }));

                const hoy = new Date();

                    for (const plan of data) {

                        if (

                            plan.estado !== "Aceptado" &&

                            plan.vigencia

                        ) {

                            const vigencia = new Date(

                                plan.vigencia + "T23:59:59"

                            );

                            if (

                                vigencia < hoy &&

                                plan.estado !== "Vencido"

                            ) {

                                updateDoc(

                                    doc(

                                        db,

                                        "clinics",

                                        clinicId,

                                        "pacientes",

                                        paciente.id,

                                        "planesTratamiento",

                                        plan.id

                                    ),

                                    {

                                        estado: "Vencido"

                                    }

                                );

                                plan.estado = "Vencido";

                            }

                        }

                    }

                setPlanes(data);

            }

        );

        return () => unsubscribe();

    }, [clinicId, paciente.id]);

    // =====================================
    // GENERAR FOLIO
    // =====================================

    const generarFolioPlan = async () => {

        const anio = new Date().getFullYear();

        const counterRef = doc(

            db,

            "clinics",

            clinicId,

            "counters",

            "treatmentPlans"

        );

        const consecutivo = await runTransaction(

            db,

            async (transaction) => {

                const snap = await transaction.get(

                    counterRef

                );

                let data = {};

                if (snap.exists()) {

                    data = snap.data();

                }

                const actual = data[anio] || 0;

                const siguiente = actual + 1;

                transaction.set(

                    counterRef,

                    {

                        ...data,

                        [anio]: siguiente

                    },

                    {

                        merge: true

                    }

                );

                return siguiente;

            }

        );

        return `PT-${anio}-${String(consecutivo).padStart(4, "0")}`;

    };

    // =====================================
    // AGREGAR PROCEDIMIENTO
    // =====================================

    const agregarPlan = async () => {

        try {

            const folio = await generarFolioPlan();

            const nuevoPlan = {

                folio,

                nombre: "Plan de tratamiento",

                fecha: new Date().toISOString(),

                estado: "Borrador",

                diagnostico: "",

                consentimiento: "",

                firma: null,

                fechaAceptacion: null,

                vigencia: null,

                discountType: "none",

                discountValue: 0,

                downPayment: 0,

                procedimientos: []

            };

            const docRef = await addDoc(

                collection(

                    db,
                    "clinics",
                    clinicId,
                    "pacientes",
                    paciente.id,
                    "planesTratamiento"

                ),

                {

                    ...nuevoPlan,

                    createdAt: serverTimestamp()

                }

            );

            setPlanes(prev => [

                ...prev,

                {

                    id: docRef.id,

                    ...nuevoPlan

                }

            ]);

            console.log("Plan creado:", docRef.id);

        } catch (error) {

            console.error(error);

            alert("No se pudo crear el plan.");

        }

    };

    const agregarProcedimiento = async (planId) => {

        const plan = planes.find(p => p.id === planId);

        if (!plan) return;

        const planActualizado = {

            ...plan,

            procedimientos: [

                ...plan.procedimientos,

                {

                    id: Date.now(),

                    order: plan.procedimientos.length + 1,

                    specialty: "",

                    category: "",

                    procedureId: "",

                    procedureName: "",

                    requiresOdontogram: false,

                    allowsSurfaces: false,

                    selectedTeeth: [],

                    selectedSurfaces: {},

                    price: "",

                    quantity: 1,

                    discountType: "none",

                    discountValue: 0

                }

            ]

        };

        setPlanes(prev =>

            prev.map(p =>

                p.id === planId

                    ? planActualizado

                    : p

            )

        );

        await guardarPlanFirestore(planActualizado);

    };

    // =====================================
    // ELIMINAR PROCEDIMIENTO
    // =====================================

    const eliminarProcedimiento = async (

        planId,

        procedimientoId

    ) => {

        const plan = planes.find(

            p => p.id === planId

        );

        if (!plan) return;

        const planActualizado = {

            ...plan,

            procedimientos:

                plan.procedimientos.filter(

                    proc => proc.id !== procedimientoId

                )

        };

        await actualizarPlanLocal(planActualizado);

    };

    // =====================================
    // ACTUALIZAR PROCEDIMIENTO
    // =====================================

    const actualizarProcedimiento = async (

        planId,

        procedimientoId,

        campo,

        valor

    ) => {

        const plan = planes.find(

            p => p.id === planId

        );

        if (!plan) return;

        const planActualizado = {

            ...plan,

            procedimientos:

                plan.procedimientos.map(proc =>

                    proc.id !== procedimientoId

                        ? proc

                        : {

                            ...proc,

                            ...(typeof campo === "object"

                                ? campo

                                : {

                                    [campo]: valor

                                })

                        }

                )

        };

        await actualizarPlanLocal(planActualizado);

    };

    // =====================================
    // ACTUALIZAR PLAN
    // =====================================

    const actualizarPlan = async (

        planId,

        campo,

        valor

    ) => {

        const plan = planes.find(

            p => p.id === planId

        );

        if (!plan) return;

        const planActualizado = {

            ...plan,

            [campo]: valor

        };

        await actualizarPlanLocal(planActualizado);

    };

    // =====================================
    // CAMBIAR ESPECIALIDAD
    // =====================================

    const cambiarEspecialidad = async (

        planId,

        procedimientoId,

        specialty

    ) => {

        const plan = planes.find(

            p => p.id === planId

        );

        if (!plan) return;

        const planActualizado = {

            ...plan,

            procedimientos:

                plan.procedimientos.map(proc =>

                    proc.id !== procedimientoId

                        ? proc

                        : {

                            ...proc,

                            specialty,

                            category: "",

                            procedureId: "",

                            procedureName: "",

                            requiresOdontogram: false,

                            allowsSurfaces: false,

                            selectedTeeth: [],

                            selectedSurfaces: {}

                        }

                )

        };

        await actualizarPlanLocal(planActualizado);

    };

    // =====================================
    // CAMBIAR CATEGORIA
    // =====================================

    const cambiarCategoria = async (

        planId,

        procedimientoId,

        category

    ) => {

        const plan = planes.find(

            p => p.id === planId

        );

        if (!plan) return;

        const planActualizado = {

            ...plan,

            procedimientos:

                plan.procedimientos.map(proc =>

                    proc.id !== procedimientoId

                        ? proc

                        : {

                            ...proc,

                            category,

                            procedureId: "",

                            procedureName: "",

                            requiresOdontogram: false,

                            allowsSurfaces: false,

                            selectedTeeth: [],

                            selectedSurfaces: {}

                        }

                )

        };

        await actualizarPlanLocal(planActualizado);

    };

    // =====================================
    // CAMBIAR PROCEDIMIENTO
    // =====================================

    const cambiarProcedimiento = async (

        planId,

        procedimientoId,

        procedure

    ) => {

        const plan = planes.find(

            p => p.id === planId

        );

        if (!plan) return;

        const planActualizado = {

            ...plan,

            procedimientos:

                plan.procedimientos.map(proc =>

                    proc.id !== procedimientoId

                        ? proc

                        : {

                            ...proc,

                            procedureId: procedure.id,

                            procedureName: procedure.name,

                            requiresOdontogram: procedure.requiresOdontogram,

                            allowsSurfaces: procedure.allowsSurfaces

                        }

                )

        };

        await actualizarPlanLocal(planActualizado);

    };

    // =====================================
    // SELECCIONAR PROCEDIMIENTO BUSCADO
    // =====================================

    const seleccionarProcedimientoBuscado = async (

        planId,

        procedimientoId,

        procedimiento

    ) => {

        const plan = planes.find(

            p => p.id === planId

        );

        if (!plan) return;

        const planActualizado = {

            ...plan,

            procedimientos:

                plan.procedimientos.map(proc =>

                    proc.id !== procedimientoId

                        ? proc

                        : {

                            ...proc,

                            specialty: procedimiento.specialty,

                            category: procedimiento.category,

                            procedureId: procedimiento.id,

                            procedureName: procedimiento.name,

                            requiresOdontogram:
                                procedimiento.requiresOdontogram,

                            allowsSurfaces:
                                procedimiento.allowsSurfaces,

                            selectedTeeth: [],

                            selectedSurfaces: {}

                        }

                )

        };

        await actualizarPlanLocal(planActualizado);

    };

    // =====================================
    // OBTENER CATEGORIAS
    // =====================================

    const obtenerCategorias = (

        specialty

    ) => {

        const esp = procedures.find(

            s =>

                s.specialty ===

                specialty

        );

        return esp

            ? esp.categories

            : [];

    };

    // =====================================
    // OBTENER PROCEDIMIENTOS
    // =====================================

    const obtenerProcedimientos = (

        specialty,

        category

    ) => {

        const esp = procedures.find(

            s =>

                s.specialty ===

                specialty

        );

        if (!esp)

            return [];

        const cat =

            esp.categories.find(

                c =>

                    c.name ===

                    category

            );

        return cat

            ? cat.procedures

            : [];

    };

    const obtenerTodosLosProcedimientos = () => {

        return procedures.flatMap(especialidad =>

            especialidad.categories.flatMap(categoria =>

                categoria.procedures.map(procedimiento => ({

                    ...procedimiento,

                    specialty: especialidad.specialty,

                    category: categoria.name

                }))

            )

        );

    };

    const obtenerTotalPlan = (plan) => {

        return plan.procedimientos.reduce(

            (total, procedimiento) =>

                total + Number(procedimiento.price || 0),

            0

        );

    };

    const obtenerResumenDientes = (procedimiento) => {

        if (!procedimiento.selectedTeeth?.length)
            return [];

        return procedimiento.selectedTeeth.map(diente => {

            const caras =
                procedimiento.selectedSurfaces?.[diente] || [];

            if (!caras.length)
                return diente;

            const abreviaturas = {

                mesial: "M",

                distal: "D",

                vestibular: "V",

                palatina: "P",

                oclusal: "O"

            };

            const textoCaras =
                caras
                    .map(c => abreviaturas[c] || c)
                    .join("");

            return `${diente} (${textoCaras})`;

        });

    };

    const obtenerSubtotalProcedimiento = (procedimiento) => {

        const precio =
            Number(procedimiento.price || 0);

        const dientes =
            procedimiento.selectedTeeth?.length || 0;

        const cantidad =
            Number(procedimiento.quantity || 1);

        const tipo =
            procedimiento.discountType || "none";

        const descuento =
            Number(procedimiento.discountValue || 0);

        let subtotal;

        if (
            procedimiento.requiresOdontogram &&
            dientes > 0
        ) {

            subtotal = precio * dientes;

        } else {

            subtotal = precio * cantidad;

        }

        if (tipo === "percent") {

            subtotal -= subtotal * (descuento / 100);

        } else if (tipo === "fixed") {

            subtotal -= descuento;

        }

        return Math.max(0, subtotal);

    };

    const obtenerTotalResumen = (plan) => {

        let total = plan.procedimientos.reduce(

            (acumulado, procedimiento) =>

                acumulado +
                obtenerSubtotalProcedimiento(
                    procedimiento
                ),

            0

        );

        const tipo =
            plan.discountType || "none";

        const descuento =
            Number(plan.discountValue || 0);

        if (tipo === "percent") {

            total -= total * (descuento / 100);

        } else if (tipo === "fixed") {

            total -= descuento;

        }

        return Math.max(0, total);

    };

    const formatearMoneda = (valor) => {

        return new Intl.NumberFormat(

            "es-MX",

            {

                style: "currency",

                currency: clinicData?.settings?.finance?.currency || "MXN"

            }

        ).format(Number(valor) || 0);

    };

    const eliminarDienteProcedimiento = async (

        planId,

        procedimientoId,

        diente

    ) => {

        const plan = planes.find(

            p => p.id === planId

        );

        if (!plan) return;

        const planActualizado = {

            ...plan,

            procedimientos:

                plan.procedimientos.map(proc => {

                    if (proc.id !== procedimientoId) {

                        return proc;

                    }

                    const nuevasSuperficies = {

                        ...proc.selectedSurfaces

                    };

                    delete nuevasSuperficies[diente];

                    return {

                        ...proc,

                        selectedTeeth:

                            proc.selectedTeeth.filter(

                                t => t !== diente

                            ),

                        selectedSurfaces:

                            nuevasSuperficies

                    };

                })

        };

        await actualizarPlanLocal(planActualizado);

    };

    const guardarPlanFirestore = async (plan) => {

        try {

            console.log("Actualizando plan...");

            await updateDoc(

                doc(

                    db,

                    "clinics",

                    clinicId,

                    "pacientes",

                    paciente.id,

                    "planesTratamiento",

                    plan.id

                ),

                {

                    nombre: plan.nombre,

                    fecha: plan.fecha,

                    estado: plan.estado,

                    diagnostico: plan.diagnostico,

                    consentimiento: plan.consentimiento,

                    firma: plan.firma,

                    discountType: plan.discountType,

                    discountValue: plan.discountValue,

                    downPayment: plan.downPayment,

                    procedimientos: plan.procedimientos,

                    fechaAceptacion: plan.fechaAceptacion,

                    vigencia: plan.vigencia,

                    cuentaPorCobrarCreada:
                        plan.cuentaPorCobrarCreada ?? false

                }

            );

            console.log("Plan actualizado correctamente.");

            return true;

        } catch (error) {

            console.error("Error actualizando plan:", error);

            alert("Error guardando el plan.");

            return false;

        }

    };

    const crearCuentaPorCobrar = async (plan) => {

        const total =
            obtenerTotalResumen(plan);

        const anticipo =
            Math.min(
                Math.max(
                    0,
                    Number(
                        plan.downPayment || 0
                    )
                ),
                total
            );

        const saldoInicial =
            Math.max(
                0,
                total - anticipo
            );

        await addDoc(

            collection(
                db,
                "clinics",
                clinicId,
                "pacientes",
                paciente.id,
                "cuentasPorCobrar"
            ),

            {

                clinicId,

                tipo:
                    "planTratamiento",

                planId:
                    plan.id,

                folio:
                    plan.folio,

                descripcion:
                    plan.nombre,

                total,

                pagado:
                    anticipo,

                saldo:
                    saldoInicial,

                estado:
                    saldoInicial > 0
                        ? "Pendiente"
                        : "Pagada",

                createdAt:
                    serverTimestamp()

            }

        );

    };

    const generarPDFPlan = (plan) => {

        const pdf = new jsPDF({

            orientation: "portrait",

            unit: "mm",

            format: "letter"

        });

        const pageWidth = pdf.internal.pageSize.getWidth();

        let y = 18;

        // ==============================
        // ENCABEZADO
        // ==============================

        pdf.setDrawColor(37, 99, 235);

        pdf.setLineWidth(0.8);

        pdf.line(
            15,
            y,
            pageWidth - 15,
            y
        );

        y += 10;

        pdf.setFont("helvetica", "bold");

        pdf.setFontSize(22);

        pdf.text(

            "PLAN DE TRATAMIENTO",

            pageWidth / 2,

            y,

            {

                align: "center"

            }

        );

        y += 8;

        pdf.setFontSize(12);

        pdf.setFont("helvetica", "normal");

        pdf.setDrawColor(220);

        pdf.line(

            15,

            y,

            pageWidth - 15,

            y

        );

        y += 12;

        // ==============================
        // DATOS DEL PACIENTE
        // ==============================

        pdf.setFont("helvetica","bold");

        pdf.setFontSize(13);

        pdf.text(

            "Datos del paciente",

            15,

            y

        );

        y += 8;

        pdf.setFont("helvetica","normal");

        pdf.setFontSize(11);

        pdf.text(

            `Paciente: ${`${paciente.nombres || ""} ${paciente.apellidos || ""}`.trim()}`,

            18,

            y

        );

        y += 7;

        pdf.text(

            `Fecha: ${new Date(plan.fecha).toLocaleDateString("es-MX")}`,

            18,

            y

        );

        y += 7;

        pdf.text(

            `Vigencia: ${

                plan.vigencia

                    ? new Date(

                        plan.vigencia + "T00:00:00"

                    ).toLocaleDateString("es-MX")

                    : "Sin definir"

            }`,

            18,

            y

        );

        y += 12;

        // ==============================
        // DIAGNÓSTICO
        // ==============================

        pdf.setFont("helvetica", "bold");

        pdf.setFontSize(13);

        pdf.text(

            "Diagnóstico",

            15,

            y

        );

        y += 8;

        pdf.setFont("helvetica", "normal");

        pdf.setFontSize(11);

        const diagnostico =

            plan.diagnostico?.trim()

                ? plan.diagnostico

                : "Sin diagnóstico.";

        const lineasDiagnostico = pdf.splitTextToSize(

            diagnostico,

            pageWidth - 30

        );

        pdf.text(

            lineasDiagnostico,

            18,

            y

        );

        y += lineasDiagnostico.length * 6 + 10;

        // ==============================
        // PROCEDIMIENTOS
        // ==============================

        pdf.setFont("helvetica", "bold");

        pdf.setFontSize(13);

        pdf.text(

            "Procedimientos",

            15,

            y

        );

        y += 8;

        // Encabezado

        pdf.setFillColor(37, 99, 235);

        pdf.setTextColor(255);

        pdf.rect(

            15,

            y,

            pageWidth - 30,

            8,

            "F"

        );

        pdf.setFontSize(10);

        pdf.text("#",18,y+5);

        pdf.text("Procedimiento",28,y+5);

        pdf.text("Importe",pageWidth-40,y+5);

        y += 10;

        pdf.setTextColor(0);

        pdf.setFont("helvetica","normal");

        plan.procedimientos.forEach((proc,index)=>{

            pdf.setDrawColor(230);

            pdf.rect(

                15,

                y-5,

                pageWidth-30,

                10

            );

            pdf.text(

                String(index+1),

                18,

                y+1

            );

            pdf.text(

                proc.procedureName || "-",

                28,

                y+1

            );

            pdf.text(

                "$ " +

                obtenerSubtotalProcedimiento(proc)

                    .toLocaleString("es-MX",{

                        minimumFractionDigits:2,

                        maximumFractionDigits:2

                    }),

                pageWidth-40,

                y+1

            );

            y += 10;

        });

        // ==============================
        // TOTALES
        // ==============================

        y += 8;

        const total = obtenerTotalResumen(plan);

        const anticipo = Number(plan.downPayment || 0);

        const saldo = Math.max(
            0,
            total - anticipo
        );

        pdf.setDrawColor(200);

        pdf.line(
            pageWidth - 90,
            y,
            pageWidth - 15,
            y
        );

        y += 8;

        pdf.setFont("helvetica","normal");

        pdf.setFontSize(11);

        pdf.text(

            "Total:",

            pageWidth - 75,

            y

        );

        pdf.text(

            "$ " +

            total.toLocaleString("es-MX",{

                minimumFractionDigits:2,

                maximumFractionDigits:2

            }),

            pageWidth - 15,

            y,

            {

                align:"right"

            }

        );

        y += 8;

        pdf.text(

            "Anticipo:",

            pageWidth - 75,

            y

        );

        pdf.text(

            "$ " +

            anticipo.toLocaleString("es-MX",{

                minimumFractionDigits:2,

                maximumFractionDigits:2

            }),

            pageWidth - 15,

            y,

            {

                align:"right"

            }

        );

        y += 8;

        pdf.setFont("helvetica","bold");

        pdf.setFontSize(13);

        pdf.text(

            "Saldo pendiente:",

            pageWidth - 75,

            y

        );

        pdf.text(

            "$ " +

            saldo.toLocaleString("es-MX",{

                minimumFractionDigits:2,

                maximumFractionDigits:2

            }),

            pageWidth - 15,

            y,

            {

                align:"right"

            }

        );

        y += 18;

        // ==============================
        // CONSENTIMIENTO INFORMADO
        // ==============================

        pdf.setFont("helvetica","bold");

        pdf.setFontSize(13);

        pdf.text(

            "Consentimiento informado",

            15,

            y

        );

        y += 10;

        pdf.setFont("helvetica","normal");

        pdf.setFontSize(10);

        const consentimiento = [

            "Declaro que el odontólogo me explicó de forma clara el diagnóstico,",

            "el plan de tratamiento propuesto, los beneficios esperados,",

            "los posibles riesgos, las alternativas disponibles y los costos",

            "correspondientes.",

            "",

            "Tuve oportunidad de hacer todas las preguntas que consideré",

            "necesarias y recibí respuesta satisfactoria antes de aceptar",

            "este tratamiento.",

            "",

            "Entiendo que durante el tratamiento pueden surgir hallazgos",

            "clínicos que hagan necesario modificar o complementar el plan",

            "originalmente propuesto.",

            "",

            "Después de recibir la información suficiente y comprenderla,",

            "acepto voluntariamente el plan de tratamiento descrito",

            "en este documento."

        ];

        pdf.text(

            consentimiento,

            18,

            y

        );

        y += consentimiento.length * 5 + 12;

        // ==============================
        // FIRMA DEL PACIENTE
        // ==============================

        pdf.setFont("helvetica","bold");

        pdf.setFontSize(13);

        pdf.text(

            "Firma del paciente",

            15,

            y

        );

        y += 10;

        if (plan.firma) {

            try {

                pdf.addImage(

                    plan.firma,

                    "PNG",

                    20,

                    y,

                    60,

                    25

                );

            } catch (error) {

                console.error(error);

            }

        }

        y += 30;

        pdf.setDrawColor(120);

        pdf.line(

            20,

            y,

            80,

            y

        );

        y += 6;

        pdf.setFont("helvetica","normal");

        pdf.setFontSize(10);

        pdf.text(

            `${paciente.nombres || ""} ${paciente.apellidos || ""}`.trim(),

            20,

            y

        );

        y += 12;

        // ==============================
        // PIE DE PÁGINA
        // ==============================

        const pageHeight = pdf.internal.pageSize.getHeight();

        pdf.setDrawColor(220);

        pdf.line(

            15,

            pageHeight - 18,

            pageWidth - 15,

            pageHeight - 18

        );

        pdf.setFontSize(9);

        pdf.setTextColor(120);

        pdf.text(

            "Documento generado por VexaDent",

            pageWidth / 2,

            pageHeight - 10,

            {

                align:"center"

            }

        );

        return pdf.output("blob");

    };

    const subirPDFPlan = async (plan, pdfBlob) => {

        try {

            const storageRef = ref(

                storage,

                `clinics/${clinicId}/pacientes/${paciente.id}/planesTratamiento/${plan.id}.pdf`

            );

            await uploadBytes(

                storageRef,

                pdfBlob,

                {

                    contentType: "application/pdf"

                }

            );

            const pdfURL = await getDownloadURL(

                storageRef

            );

            await updateDoc(

                doc(

                    db,

                    "clinics",

                    clinicId,

                    "pacientes",

                    paciente.id,

                    "planesTratamiento",

                    plan.id

                ),

                {

                    pdfURL

                }

            );

            console.log("PDF subido correctamente.");

            console.log(pdfURL);

            return pdfURL;

        } catch (error) {

            console.error(error);

            alert("No fue posible subir el PDF.");

            return null;

        }

    };

    const enviarPlanWhatsApp = async (plan) => {

        try {

            if (!paciente.whatsapp) {

                alert("El paciente no tiene un número de WhatsApp registrado.");

                return;

            }

            if (!plan.pdfURL) {

                alert("Este plan todavía no tiene un PDF generado.");

                return;

            }

            const resultado = await sendWhatsAppFileVPS(

                clinicId,

                paciente.whatsapp,

                plan.pdfURL,

                `${plan.nombre}.pdf`,

                `Estimado(a) ${`${paciente.nombres || ""} ${paciente.apellidos || ""}`.trim()}:

    Adjuntamos su Plan de Tratamiento en formato PDF.

    Si tiene alguna duda respecto al tratamiento o al presupuesto, con gusto podremos resolverla.

    Gracias por su confianza.`

            );

            if (resultado.success) {

                alert("Plan enviado correctamente por WhatsApp.");

            } else {

                alert(resultado.error || "No fue posible enviar el plan.");

            }

        } catch (error) {

            console.error(error);

            alert("Error enviando el plan por WhatsApp.");

        }

    };

    const actualizarSaldoPaciente = async (importe) => {

        try {

            await updateDoc(

                doc(

                    db,

                    "clinics",

                    clinicId,

                    "pacientes",

                    paciente.id

                ),

                {

                    saldoPendiente: increment(importe)

                }

            );

            console.log("Saldo del paciente actualizado.");

        } catch (error) {

            console.error(error);

            alert("No fue posible actualizar el saldo del paciente.");

        }

    };

    const actualizarPlanLocal = async (planActualizado) => {

        setPlanes(prev =>

            prev.map(plan =>

                plan.id === planActualizado.id

                    ? planActualizado

                    : plan

            )

        );

        await guardarPlanFirestore(planActualizado);

    };

    const eliminarPlan = async (plan) => {

        if (plan.estado === "Aceptado") {

            alert(

                "Los planes aceptados forman parte del expediente clínico y no pueden eliminarse."

            );

            return;

        }

        const confirmar = await requestVexaConfirm(

            `¿Deseas eliminar definitivamente el plan ${plan.folio}?\n\nEsta acción no se puede deshacer.`

        );

        if (!confirmar) return;

        try {

            if (plan.pdfURL) {

                try {

                    const storageRef = ref(

                        storage,

                        `clinics/${clinicId}/pacientes/${paciente.id}/planesTratamiento/${plan.id}.pdf`

                    );

                    await deleteObject(storageRef);

                } catch (error) {

                    console.warn(

                        "No fue posible eliminar el PDF.",

                        error

                    );

                }

            }

            await deleteDoc(

                doc(

                    db,

                    "clinics",

                    clinicId,

                    "pacientes",

                    paciente.id,

                    "planesTratamiento",

                    plan.id

                )

            );

            if (planExpandido === plan.id) {

                setPlanExpandido(null);

            }

            setPlanes(prev =>

                prev.filter(

                    p => p.id !== plan.id

                )

            );

        } catch (error) {

            console.error(error);

            alert("No fue posible eliminar el plan.");

        }

    };

    return (

        <div className="space-y-6">

            {/* Encabezado */}

            <div className="flex items-center justify-between">

                <div className="flex items-center gap-3">

                    <div className="p-3 rounded-xl bg-blue-100">

                        <FileText
                            className="text-blue-600"
                            size={24}
                        />

                    </div>

                    <div>

                        <h2 className="text-2xl font-bold text-gray-800">

                            Plan de Tratamiento

                        </h2>

                        <p className="text-gray-500">

                            Presupuesto y consentimiento informado

                        </p>

                    </div>

                </div>

            </div>

            {/* Lista de procedimientos */}

            <div
                className="flex flex-col gap-4 mb-6"
            >

                <div
                    className="flex flex-wrap gap-4 items-center"
                >

                    <input

                        type="text"

                        placeholder="Buscar plan..."

                        value={buscarPlan}

                        onChange={(e)=>

                            setBuscarPlan(e.target.value)

                        }

                        className="flex-1 min-w-[220px] border rounded-xl px-4 py-3"

                    />

                    <select

                        value={filtroEstado}

                        onChange={(e)=>

                            setFiltroEstado(e.target.value)

                        }

                        className="border rounded-xl px-4 py-3"

                    >

                        <option value="Todos">

                            Todos

                        </option>

                        <option value="Borrador">

                            Borrador

                        </option>

                        <option value="Aceptado">

                            Aceptado

                        </option>

                        <option value="Vencido">

                            Vencido

                        </option>

                    </select>

                </div>

                <div className="flex justify-center">

                    <button

                        onClick={agregarPlan}

                        className="flex items-center gap-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 transition"

                    >

                        <Plus size={20} />

                        Nuevo plan de tratamiento

                    </button>

                </div>

            </div>

            {planes.length === 0 && (

                <div className="bg-white rounded-2xl border shadow-sm p-10">

                    <div className="flex flex-col items-center justify-center">

                        <div className="p-5 rounded-full bg-blue-50">

                            <FileText
                                size={42}
                                className="text-blue-600"
                            />

                        </div>

                        <h3 className="mt-5 text-xl font-semibold">

                            Plan vacío ({procedures.length} especialidades)

                        </h3>

                        <p className="mt-2 text-gray-500 text-center max-w-lg">

                            Aquí podrás agregar uno o varios procedimientos,
                            asignar su costo, generar el presupuesto,
                            obtener la firma del paciente y enviar el documento
                            por WhatsApp.

                        </p>

                    </div>

                </div>

            )}

            {planesFiltrados.map((plan, index) => {

                const totalPlan = obtenerTotalResumen(plan);

                const anticipo =
                    Number(plan.downPayment || 0);

                const saldoPendiente =
                    plan.saldoPendiente !== undefined

                        ? Number(plan.saldoPendiente)

                        : Math.max(
                            0,
                            totalPlan - anticipo
                        );

                const planBloqueado = plan.estado === "Aceptado";

                return (

                    <div
                        key={plan.id}
                        className="bg-white rounded-2xl border shadow-sm p-6 space-y-5"
                    >

                        {/* Encabezado */}

                        <div className="flex flex-col gap-5">

                            {/* Primera fila */}

                            <div className="flex justify-between items-start flex-wrap gap-4">

                                <div>

                                    <div className="flex items-center gap-3">

                                        <FileText
                                            size={22}
                                            className="text-blue-600"
                                        />

                                        <div>

                                            <div className="text-xl font-bold text-gray-900">

                                                {plan.folio || "PT-SIN-FOLIO"}

                                            </div>

                                            <div className="text-sm text-gray-500">

                                                {plan.nombre}

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <span

                                    className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold ${
                                        plan.estado === "Aceptado"
                                            ? "bg-green-100 text-green-700"
                                            : plan.estado === "Vencido"
                                            ? "bg-red-100 text-red-700"
                                            : "bg-yellow-100 text-yellow-700"
                                    }`}

                                >

                                    {planBloqueado && (

                                        <Lock size={15} />

                                    )}

                                    {plan.estado}

                                </span>

                            </div>

                            {/* Resumen */}

                            <div className="grid grid-cols-2 md:grid-cols-4 gap-5">

                                <div>

                                    <div className="text-xs uppercase tracking-wide text-gray-400">

                                        Fecha

                                    </div>

                                    <div className="font-semibold">

                                        {new Date(plan.fecha).toLocaleDateString("es-MX")}

                                    </div>

                                </div>

                                <div>

                                    <div className="text-xs uppercase tracking-wide text-gray-400">

                                        Procedimientos

                                    </div>

                                    <div className="font-semibold">

                                        {plan.procedimientos.length}

                                    </div>

                                </div>

                                <div>

                                    <div className="text-xs uppercase tracking-wide text-gray-400">

                                        Total

                                    </div>

                                    <div className="font-semibold text-blue-700">

                                        {formatearMoneda(

                                            obtenerTotalResumen(plan)

                                        )}

                                    </div>

                                </div>

                                <div>

                                    <div className="text-xs uppercase tracking-wide text-gray-400">

                                        Saldo

                                    </div>

                                    <div className="font-semibold text-red-600">

                                        {formatearMoneda(

                                            Math.max(

                                                0,

                                                obtenerTotalResumen(plan) -

                                                Number(plan.downPayment || 0)

                                            )

                                        )}

                                    </div>

                                </div>

                            </div>

                            {/* Botones */}

                            <div className="flex flex-wrap gap-3">

                                {plan.estado !== "Aceptado" && (

                                    <button

                                        onClick={() => eliminarPlan(plan)}

                                        className="
                                            flex
                                            items-center
                                            gap-2
                                            bg-red-600
                                            hover:bg-red-700
                                            text-white
                                            rounded-xl
                                            px-5
                                            py-2.5
                                            transition
                                        "

                                    >

                                        <Trash2 size={18} />

                                        Eliminar

                                    </button>

                                )}

                                {!planBloqueado && (

                                    <button

                                        onClick={() => {

                                            if (!plan.diagnostico?.trim()) {

                                                alert("Debes escribir el diagnóstico antes de presentar el plan.");

                                                return;

                                            }

                                            if (plan.procedimientos.length === 0) {

                                                alert("Debes agregar al menos un procedimiento.");

                                                return;

                                            }

                                            if (!plan.vigencia) {

                                                alert("Debes seleccionar la vigencia del presupuesto.");

                                                return;

                                            }

                                            setShowSignature(plan);

                                        }}

                                        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-5 py-2.5 transition"

                                    >

                                        <Presentation size={18} />

                                        Presentar al paciente

                                    </button>

                                )}

                                {plan.pdfURL && (

                                    <button

                                        onClick={() =>

                                            window.open(

                                                plan.pdfURL,

                                                "_blank"

                                            )

                                        }

                                        className="flex items-center gap-2 border border-gray-300 hover:bg-gray-100 rounded-xl px-5 py-2.5 transition"

                                    >

                                        <Eye size={18} />

                                        Ver PDF

                                    </button>

                                )}

                                {plan.pdfURL && (

                                    <button

                                        onClick={() => {

                                            const link = document.createElement("a");

                                            link.href = plan.pdfURL;

                                            link.download = `${plan.folio || plan.nombre}.pdf`;

                                            document.body.appendChild(link);

                                            link.click();

                                            document.body.removeChild(link);

                                        }}

                                        className="flex items-center gap-2 border border-gray-300 hover:bg-gray-100 rounded-xl px-5 py-2.5 transition"

                                    >

                                        <Download size={18} />

                                        Descargar

                                    </button>

                                )}

                                {plan.pdfURL && (

                                    <button

                                        onClick={() => enviarPlanWhatsApp(plan)}

                                        className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white rounded-xl px-5 py-2.5 transition"

                                    >

                                        <MessageCircle size={18} />

                                        WhatsApp

                                    </button>

                                )}

                            </div>

                        </div>

                        <div className="pt-2">

                            <button

                                onClick={() =>

                                    setPlanExpandido(

                                        planExpandido === plan.id

                                            ? null

                                            : plan.id

                                    )

                                }

                                className="
                                    w-full
                                    flex
                                    justify-center
                                    items-center
                                    gap-2
                                    py-3
                                    rounded-xl
                                    text-gray-600
                                    hover:text-blue-600
                                    hover:bg-blue-50
                                    transition-all
                                "

                            >

                                {

                                    planExpandido === plan.id

                                        ? <ChevronUp size={18}/>

                                        : <ChevronDown size={18}/>

                                }

                                {

                                    planExpandido === plan.id

                                        ? "Ocultar plan"

                                        : "Explorar plan"

                                }

                            </button>

                        </div>

                        {planExpandido === plan.id && (

                        <>

                        {/* Diagnóstico */}

                        <div>

                            <label className="block text-sm font-medium mb-2">

                                Diagnóstico

                            </label>

                            <textarea

                                rows={4}

                                value={plan.diagnostico}

                                onChange={(e) =>

                                    setPlanes(prev =>

                                        prev.map(p =>

                                            p.id !== plan.id

                                                ? p

                                                : {

                                                    ...p,

                                                    diagnostico: e.target.value

                                                }

                                        )

                                    )

                                }

                                disabled={planBloqueado}

                                className={`w-full border rounded-xl px-4 py-3 resize-none ${
                                    planBloqueado
                                        ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                        : ""
                                }`}

                                placeholder="Escribe el diagnóstico del paciente..."

                            />

                        </div>

                        {/* Procedimientos */}

                        <div>

                            <div
                                className="
                                    sticky
                                    top-4
                                    z-20
                                    flex
                                    justify-between
                                    items-center
                                    mb-4
                                    bg-white/90
                                    backdrop-blur
                                    rounded-xl
                                    px-4
                                    py-3
                                    border
                                    shadow-sm
                                "
                            >

                                <h4 className="font-semibold text-lg">

                                    Procedimientos

                                </h4>

                                <button

                                    onClick={() => agregarProcedimiento(plan.id)}

                                    disabled={planBloqueado}

                                    className={`
                                        flex
                                        items-center
                                        gap-2
                                        rounded-xl
                                        px-5
                                        py-2.5
                                        shadow-md
                                        transition-all
                                        ${
                                            planBloqueado
                                                ? "bg-gray-300 text-gray-500 cursor-not-allowed shadow-none"
                                                : "bg-blue-600 hover:bg-blue-700 text-white hover:shadow-lg"
                                        }
                                    `}

                                >

                                    <Plus size={18} />

                                    Agregar procedimiento

                                </button>

                            </div>

                            {plan.procedimientos.length === 0 && (

                                <div className="border rounded-xl p-6 text-center text-gray-500">

                                    Este plan todavía no tiene procedimientos.

                                </div>

                            )}

                            <DndContext
                                collisionDetection={closestCenter}
                            >

                                <SortableContext

                                    items={
                                        [...plan.procedimientos]

                                            .sort((a, b) => a.order - b.order)

                                            .map(p => p.id)
                                    }

                                    strategy={verticalListSortingStrategy}

                                >

                            {[...plan.procedimientos]

                                .sort((a, b) => a.order - b.order)

                                .map((item, procIndex) => {

                                const categorias =
                                    obtenerCategorias(item.specialty);

                                const procedimientos =
                                    obtenerProcedimientos(
                                        item.specialty,
                                        item.category
                                    );

                                const resultadosBusqueda =

                                    procedureSearch[item.id]

                                        ? obtenerTodosLosProcedimientos()

                                            .filter(proc =>

                                                proc.name

                                                    .toLowerCase()

                                                    .includes(

                                                        procedureSearch[item.id]

                                                            .toLowerCase()

                                                    )

                                            )

                                            .slice(0, 8)

                                        : [];

                                return (

                                    <div
                                        key={item.id}
                                        className="border rounded-xl p-5 mb-5 bg-gray-50 space-y-5"
                                    >

                                        <div className="flex justify-between items-center">

                                            <h5 className="font-semibold">

                                                Procedimiento {procIndex + 1}

                                            </h5>

                                            <button

                                                onClick={() =>
                                                    eliminarProcedimiento(
                                                        plan.id,
                                                        item.id
                                                    )
                                                }

                                                disabled={planBloqueado}

                                                className={`
                                                    text-sm
                                                    ${
                                                        planBloqueado
                                                            ? "text-gray-400 cursor-not-allowed"
                                                            : "text-red-600 hover:text-red-700"
                                                    }
                                                `}

                                            >

                                                Eliminar

                                            </button>

                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

                                            <div className="md:col-span-2">

                                                <label className="block text-sm font-medium mb-2">

                                                    Buscar procedimiento

                                                </label>

                                                <input

                                                    type="text"

                                                    placeholder="Escribe el nombre del procedimiento..."

                                                    value={procedureSearch[item.id] || ""}

                                                    onChange={(e)=>

                                                        setProcedureSearch(prev => ({

                                                            ...prev,

                                                            [item.id]: e.target.value

                                                        }))

                                                    }

                                                    disabled={planBloqueado}

                                                    className={`w-full border rounded-xl px-4 py-3 ${
                                                        planBloqueado
                                                            ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                            : ""
                                                    }`}

                                                />

                                                {resultadosBusqueda.length > 0 && (

                                                    <div

                                                        style={{

                                                            marginTop:8,

                                                            border:"1px solid #d1d5db",

                                                            borderRadius:12,

                                                            overflow:"hidden",

                                                            background:"#fff",

                                                            boxShadow:"0 6px 18px rgba(0,0,0,.08)",

                                                            maxHeight:300,

                                                            overflowY:"auto"

                                                        }}

                                                    >

                                                        {resultadosBusqueda.map(proc => (

                                                            <button

                                                                key={proc.id}

                                                                type="button"

                                                                onClick={() => {

                                                                    seleccionarProcedimientoBuscado(

                                                                        plan.id,

                                                                        item.id,

                                                                        proc

                                                                    );

                                                                    setProcedureSearch(prev => ({

                                                                        ...prev,

                                                                        [item.id]: ""

                                                                    }));

                                                                }}

                                                                style={{

                                                                    width:"100%",

                                                                    padding:"12px 16px",

                                                                    textAlign:"left",

                                                                    border:"none",

                                                                    borderBottom:"1px solid #e5e7eb",

                                                                    background:"#fff",

                                                                    cursor:"pointer"

                                                                }}

                                                                onMouseEnter={(e)=>{

                                                                    e.currentTarget.style.background="#eff6ff";

                                                                }}

                                                                onMouseLeave={(e)=>{

                                                                    e.currentTarget.style.background="#fff";

                                                                }}

                                                            >

                                                                <div

                                                                    style={{

                                                                        fontWeight:600

                                                                    }}

                                                                >

                                                                    {proc.name}

                                                                </div>

                                                                <div

                                                                    style={{

                                                                        fontSize:12,

                                                                        color:"#6b7280",

                                                                        marginTop:2

                                                                    }}

                                                                >

                                                                    {proc.specialty}

                                                                    {" • "}

                                                                    {proc.category}

                                                                </div>

                                                            </button>

                                                        ))}

                                                    </div>

                                                )}

                                            </div>

                                            {/* ESPECIALIDAD */}

                                            <div>

                                                <label className="block text-sm font-medium mb-2">

                                                    Especialidad

                                                </label>

                                                <select

                                                    value={item.specialty}

                                                    disabled={planBloqueado}

                                                    onChange={(e)=>

                                                        cambiarEspecialidad(

                                                            plan.id,

                                                            item.id,

                                                            e.target.value

                                                        )

                                                    }

                                                    className={`w-full border rounded-xl px-4 py-3 ${
                                                        planBloqueado
                                                            ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                            : ""
                                                    }`}

                                                >

                                                    <option value="">

                                                        Seleccionar...

                                                    </option>

                                                    {

                                                        procedures.map(

                                                            esp=>(

                                                                <option

                                                                    key={esp.specialty}

                                                                    value={esp.specialty}

                                                                >

                                                                    {esp.specialty}

                                                                </option>

                                                            )

                                                        )

                                                    }

                                                </select>

                                            </div>

                                            {/* CATEGORÍA */}

                                            <div>

                                                <label className="block text-sm font-medium mb-2">

                                                    Categoría

                                                </label>

                                                <select

                                                    value={item.category}

                                                    disabled={!item.specialty || planBloqueado}

                                                    onChange={(e)=>

                                                        cambiarCategoria(

                                                            plan.id,

                                                            item.id,

                                                            e.target.value

                                                        )

                                                    }

                                                    className={`w-full border rounded-xl px-4 py-3 ${
                                                        planBloqueado
                                                            ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                            : ""
                                                    }`}

                                                >

                                                    <option value="">

                                                        Seleccionar...

                                                    </option>

                                                    {

                                                        categorias.map(

                                                            cat=>(

                                                                <option

                                                                    key={cat.name}

                                                                    value={cat.name}

                                                                >

                                                                    {cat.name}

                                                                </option>

                                                            )

                                                        )

                                                    }

                                                </select>

                                            </div>

                                            {/* PROCEDIMIENTO */}

                                            <div>

                                                <label className="block text-sm font-medium mb-2">

                                                    Procedimiento

                                                </label>

                                                <select

                                                    value={item.procedureId}

                                                    disabled={!item.category || planBloqueado}

                                                    onChange={(e)=>{

                                                        const proc = procedimientos.find(

                                                            p => p.id === e.target.value

                                                        );

                                                        if(proc){

                                                            cambiarProcedimiento(

                                                                plan.id,

                                                                item.id,

                                                                proc

                                                            );

                                                        }

                                                    }}

                                                    className={`w-full border rounded-xl px-4 py-3 ${
                                                        planBloqueado
                                                            ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                            : ""
                                                    }`}

                                                >

                                                    <option value="">

                                                        Seleccionar...

                                                    </option>

                                                    {

                                                        procedimientos.map(

                                                            proc=>(

                                                                <option

                                                                    key={proc.id}

                                                                    value={proc.id}

                                                                >

                                                                    {proc.name}

                                                                </option>

                                                            )

                                                        )

                                                    }

                                                </select>

                                            </div>

                                            {/* COSTO */}

                                            <div>

                                                <label className="block text-sm font-medium mb-2">

                                                    Costo

                                                </label>

                                                <input

                                                    type="number"

                                                    placeholder="$0.00"

                                                    value={item.price}

                                                    disabled={planBloqueado}

                                                    onChange={(e)=>

                                                        actualizarProcedimiento(

                                                            plan.id,

                                                            item.id,

                                                            "price",

                                                            e.target.value

                                                        )

                                                    }

                                                    className={`w-full border rounded-xl px-4 py-3 ${
                                                        planBloqueado
                                                            ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                            : ""
                                                    }`}

                                                />

                                                {!item.requiresOdontogram && (

                                                    <div className="mt-4">

                                                        <label className="block text-sm font-medium mb-2">

                                                            Cantidad

                                                        </label>

                                                        <input

                                                            type="number"

                                                            min={1}

                                                            value={item.quantity}

                                                            disabled={planBloqueado}

                                                            onChange={(e)=>

                                                                actualizarProcedimiento(

                                                                    plan.id,

                                                                    item.id,

                                                                    "quantity",

                                                                    Math.max(

                                                                        1,

                                                                        Number(e.target.value) || 1

                                                                    )

                                                                )

                                                            }

                                                            className={`w-full border rounded-xl px-4 py-3 ${
                                                                planBloqueado
                                                                    ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                                    : ""
                                                            }`}

                                                        />

                                                    </div>

                                                )}

                                                <div className="mt-4">

                                                    <label className="block text-sm font-medium mb-2">

                                                        Descuento

                                                    </label>

                                                    <div className="flex gap-3">

                                                        <select

                                                            value={item.discountType}

                                                            disabled={planBloqueado}

                                                            onChange={(e)=>

                                                                actualizarProcedimiento(

                                                                    plan.id,

                                                                    item.id,

                                                                    "discountType",

                                                                    e.target.value

                                                                )

                                                            }

                                                            className={`border rounded-xl px-3 py-3 ${
                                                                planBloqueado
                                                                    ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                                    : ""
                                                            }`}

                                                        >

                                                            <option value="none">

                                                                Ninguno

                                                            </option>

                                                            <option value="percent">

                                                                %

                                                            </option>

                                                            <option value="fixed">

                                                                $

                                                            </option>

                                                        </select>

                                                        <input

                                                            type="number"

                                                            min={0}

                                                            value={item.discountValue || ""}

                                                            disabled={planBloqueado}

                                                            onChange={(e)=>

                                                                actualizarProcedimiento(

                                                                    plan.id,

                                                                    item.id,

                                                                    "discountValue",

                                                                    Number(e.target.value) || 0

                                                                )

                                                            }

                                                            className={`flex-1 border rounded-xl px-4 py-3 ${
                                                                planBloqueado
                                                                    ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                                    : ""
                                                            }`}

                                                        />

                                                    </div>

                                                </div>

                                                {obtenerResumenDientes(item).length > 0 && (

                                                    <div
                                                        style={{
                                                            marginTop: 12
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                fontSize: 12,
                                                                fontWeight: 600,
                                                                color: "#374151",
                                                                marginBottom: 6
                                                            }}
                                                        >
                                                            Dientes seleccionados
                                                        </div>

                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexWrap: "wrap",
                                                                gap: 6
                                                            }}
                                                        >

                                                            {obtenerResumenDientes(item).map((texto, index) => {

                                                                const diente =
                                                                    item.selectedTeeth[index];

                                                                return (

                                                                    <div
                                                                        key={diente}
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 8,
                                                                            background: "#dbeafe",
                                                                            color: "#1d4ed8",
                                                                            borderRadius: 999,
                                                                            padding: "4px 6px 4px 12px",
                                                                            fontSize: 12,
                                                                            fontWeight: 500
                                                                        }}
                                                                    >

                                                                        <span>

                                                                            {texto}

                                                                        </span>

                                                                        <button

                                                                            onClick={() =>

                                                                                eliminarDienteProcedimiento(

                                                                                    plan.id,

                                                                                    item.id,

                                                                                    diente

                                                                                )

                                                                            }

                                                                            style={{

                                                                                width: 20,

                                                                                height: 20,

                                                                                borderRadius: "50%",

                                                                                border: "none",

                                                                                background: "#2563eb",

                                                                                color: "#fff",

                                                                                cursor: "pointer",

                                                                                display: "flex",

                                                                                alignItems: "center",

                                                                                justifyContent: "center",

                                                                                fontSize: 12,

                                                                                fontWeight: 700,

                                                                                lineHeight: 1

                                                                            }}

                                                                            title="Eliminar diente"

                                                                        >

                                                                            ×

                                                                        </button>

                                                                    </div>

                                                                );

                                                            })}

                                                        </div>

                                                    </div>

                                                )}

                                            </div>

                                        </div>

                                            {item.requiresOdontogram && (

                                                    <div
                                                        style={{
                                                            marginTop: 20,
                                                            width: "100%"
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                width: "100%"
                                                            }}
                                                        >

                                                            <Odontograma

                                                                mode="treatment"

                                                                readOnly={planBloqueado}

                                                                value={{

                                                                    teeth:
                                                                        item.selectedTeeth || [],

                                                                    surfaces:
                                                                        item.selectedSurfaces || {},

                                                                    allowsSurfaces:
                                                                        item.allowsSurfaces

                                                                }}

                                                                onChange={(nuevo) => {

                                                                    if (planBloqueado) return;

                                                                    actualizarProcedimiento(

                                                                        plan.id,

                                                                        item.id,

                                                                        {

                                                                            selectedTeeth:
                                                                                nuevo.teeth || [],

                                                                            selectedSurfaces:
                                                                                nuevo.surfaces || {}

                                                                        }

                                                                    );

                                                                }}

                                                            />

                                                        </div>

                                                    </div>

                                                )}

                                    </div>

                                );

                            })}

                                </SortableContext>

                        </DndContext>

                            <div
                                style={{
                                    marginTop: 24,
                                    padding: 20,
                                    background: "#f8fafc",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: 12
                                }}
                            >

                                <h3
                                    style={{
                                        margin: 0,
                                        marginBottom: 16,
                                        fontSize: 18
                                    }}
                                >
                                    Resumen del plan
                                </h3>

                                {plan.procedimientos.map(proc => (

                                    <div
                                        key={proc.id}
                                        style={{
                                            marginBottom: 18,
                                            paddingBottom: 18,
                                            borderBottom: "1px solid #e5e7eb"
                                        }}
                                    >

                                        <div
                                            style={{
                                                fontWeight: 600,
                                                fontSize: 15
                                            }}
                                        >
                                            {proc.procedureName || "Procedimiento"}
                                        </div>

                                        {obtenerResumenDientes(proc).length > 0 && (

                                            <div
                                                style={{
                                                    marginTop: 6,
                                                    color: "#4b5563",
                                                    fontSize: 13
                                                }}
                                            >
                                                {obtenerResumenDientes(proc).join(", ")}
                                            </div>

                                        )}

                                        <div
                                            style={{
                                                marginTop: 8,
                                                fontWeight: 600
                                            }}
                                        >
                                            $

                                            {obtenerSubtotalProcedimiento(proc).toLocaleString("es-MX", {

                                                minimumFractionDigits: 2,

                                                maximumFractionDigits: 2

                                            })}
                                        </div>

                                    </div>

                                ))}

                                <div
                                    style={{
                                        marginTop: 20,
                                        paddingTop: 16,
                                        borderTop: "1px solid #e5e7eb"
                                    }}
                                >

                                    <div
                                        style={{
                                            fontWeight: 600,
                                            marginBottom: 10
                                        }}
                                    >
                                        Descuento global
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            gap: 10
                                        }}
                                    >

                                        <select

                                            value={plan.discountType}

                                            disabled={planBloqueado}

                                            onChange={(e)=>

                                                actualizarPlan(

                                                    plan.id,

                                                    "discountType",

                                                    e.target.value

                                                )

                                            }

                                            className={`border rounded-xl px-3 py-2 ${
                                                planBloqueado
                                                    ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                    : ""
                                            }`}

                                        >

                                            <option value="none">

                                                Ninguno

                                            </option>

                                            <option value="percent">

                                                %

                                            </option>

                                            <option value="fixed">

                                                $

                                            </option>

                                        </select>

                                        <input

                                            type="number"

                                            min={0}

                                            value={plan.discountValue || ""}

                                            disabled={planBloqueado}

                                            onChange={(e)=>

                                                actualizarPlan(

                                                    plan.id,

                                                    "discountValue",

                                                    Number(e.target.value) || 0

                                                )

                                            }

                                            className={`flex-1 border rounded-xl px-4 py-2 ${
                                                planBloqueado
                                                    ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                    : ""
                                            }`}

                                        />

                                    </div>

                                </div>

                                <div
                                    style={{
                                        marginTop: 20
                                    }}
                                >

                                    <label
                                        style={{
                                            display: "block",
                                            fontWeight: 600,
                                            marginBottom: 8
                                        }}
                                    >
                                        Anticipo
                                    </label>

                                    <input

                                        type="number"

                                        min={0}

                                        value={plan.downPayment || ""}

                                        disabled={planBloqueado}

                                        onChange={(e)=>

                                            actualizarPlan(

                                                plan.id,

                                                "downPayment",

                                                Number(e.target.value) || 0

                                            )

                                        }

                                        className={`w-full border rounded-xl px-4 py-2 ${
                                            planBloqueado
                                                ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                : ""
                                        }`}

                                    />

                                </div>

                                <div
                                    style={{
                                        marginTop:20
                                    }}
                                >

                                    <label
                                        style={{
                                            display:"block",
                                            fontWeight:600,
                                            marginBottom:8
                                        }}
                                    >

                                        Vigencia del presupuesto

                                    </label>

                                    <input

                                        type="date"

                                        value={plan.vigencia || ""}

                                        disabled={planBloqueado}

                                        onChange={(e)=>

                                            actualizarPlan(

                                                plan.id,

                                                "vigencia",

                                                e.target.value

                                            )

                                        }

                                        className={`w-full border rounded-xl px-4 py-2 ${
                                            planBloqueado
                                                ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                                                : ""
                                        }`}

                                    />

                                    <div
                                        style={{
                                            marginTop:8,
                                            color:"#6b7280",
                                            fontSize:13
                                        }}
                                    >

                                        Después de esta fecha los costos del tratamiento podrán modificarse.

                                    </div>

                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: 20,
                                        paddingTop: 16,
                                        borderTop: "2px solid #d1d5db",
                                        fontWeight: 700,
                                        fontSize: 18
                                    }}
                                >

                                    <span>Total</span>

                                    <span>

                                        $

                                        {obtenerTotalResumen(plan).toLocaleString("es-MX", {

                                            minimumFractionDigits: 2,

                                            maximumFractionDigits: 2

                                        })}

                                    </span>

                                </div>

                            </div>

                        </div>

                        </>
                        )}

                        {/* Total del plan */}

                        <div className="flex justify-end border-t pt-5">

                            <div className="bg-green-50 border border-green-200 rounded-2xl px-6 py-4">

                                <div className="flex items-center gap-3">

                                    <DollarSign
                                        className="text-green-600"
                                    />

                                    <div>

                                        <div className="space-y-2">

                                            <div className="flex justify-between text-sm">

                                                <span>Total</span>

                                                <span>

                                                    $

                                                    {totalPlan.toLocaleString("es-MX", {

                                                        minimumFractionDigits: 2,

                                                        maximumFractionDigits: 2

                                                    })}

                                                </span>

                                            </div>

                                            <div className="flex justify-between text-sm">

                                                <span>Anticipo</span>

                                                <span>

                                                    $

                                                    {anticipo.toLocaleString("es-MX", {

                                                        minimumFractionDigits: 2,

                                                        maximumFractionDigits: 2

                                                    })}

                                                </span>

                                            </div>

                                            <div
                                                className="
                                                    border-t
                                                    pt-3
                                                    mt-3
                                                    grid
                                                    grid-cols-2
                                                    items-center
                                                    gap-4
                                                    font-bold
                                                    text-lg
                                                    text-green-700
                                                "
                                            >

                                                <div>

                                                    Saldo pendiente

                                                </div>

                                                <div className="text-right">

                                                    $

                                                    {saldoPendiente.toLocaleString("es-MX", {

                                                        minimumFractionDigits: 2,

                                                        maximumFractionDigits: 2

                                                    })}

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                );

            })}

            {showSignature && (

                <div
                    style={{

                        position: "fixed",

                        inset: 0,

                        background: "rgba(0,0,0,.55)",

                        zIndex: 9999,

                        display: "flex",

                        justifyContent: "center",

                        alignItems: "center",

                        padding: 30

                    }}
                >

                    <div
                        style={{

                            background: "#fff",

                            borderRadius: 16,

                            width: "100%",

                            maxWidth: 1000,

                            maxHeight: "90vh",

                            overflowY: "auto",

                            padding: 32

                        }}
                    >

                        <div
                            style={{

                                borderBottom:"2px solid #e5e7eb",

                                paddingBottom:20,

                                marginBottom:30

                            }}
                        >

                            <h1
                                style={{

                                    margin:0,

                                    fontSize:32,

                                    fontWeight:700,

                                    color:"#1f2937"

                                }}
                            >

                                Plan de Tratamiento

                            </h1>

                            <div
                                style={{

                                    marginTop:12,

                                    color:"#6b7280",

                                    fontSize:15

                                }}
                            >

                                Revise cuidadosamente la siguiente información antes de firmar.

                            </div>

                        </div>

                        <div
                            style={{

                                display:"grid",

                                gridTemplateColumns:"1fr 1fr",

                                gap:20,

                                marginBottom:30

                            }}
                        >

                            <div>

                                <strong>Paciente</strong>

                                <div>

                                    {`${paciente.nombres || ""} ${paciente.apellidos || ""}`.trim()}

                                </div>

                            </div>

                            <div>

                                <strong>Fecha</strong>

                                <div>

                                    {new Date(showSignature.fecha).toLocaleDateString("es-MX")}

                                </div>

                            </div>

                            <div>

                                <strong>Vigencia</strong>

                                <div>

                                    {

                                        showSignature.vigencia

                                            ? new Date(

                                                showSignature.vigencia + "T00:00:00"

                                            ).toLocaleDateString("es-MX")

                                            : "Sin definir"

                                    }

                                </div>

                            </div>

                            

                            <div>

                                <strong>Estado</strong>

                                <div>

                                    {showSignature.estado}

                                </div>

                            </div>

                        </div>

                        <div
                            style={{
                                marginBottom:30
                            }}
                        >

                            <div
                                style={{
                                    fontWeight:700,
                                    marginBottom:10,
                                    fontSize:18
                                }}
                            >

                                Diagnóstico

                            </div>

                            <div
                                style={{
                                    border:"1px solid #d1d5db",
                                    borderRadius:12,
                                    padding:16,
                                    lineHeight:1.7,
                                    minHeight:80,
                                    whiteSpace:"pre-wrap"
                                }}
                            >

                                {showSignature.diagnostico || "Sin diagnóstico."}

                            </div>

                        </div>

                        <div
                            style={{
                                marginBottom:30
                            }}
                        >

                            <div
                                style={{
                                    fontWeight:700,
                                    marginBottom:15,
                                    fontSize:18
                                }}
                            >

                                Procedimientos

                            </div>

                            {showSignature.procedimientos.map((proc,index)=>(

                                <div

                                    key={proc.id}

                                    style={{

                                        border:"1px solid #e5e7eb",

                                        borderRadius:12,

                                        padding:16,

                                        marginBottom:12

                                    }}

                                >

                                    <div
                                        style={{
                                            fontWeight:600
                                        }}
                                    >

                                        {index+1}. {proc.procedureName}

                                    </div>

                                    <div
                                        style={{
                                            marginTop:8,
                                            color:"#6b7280"
                                        }}
                                    >

                                        {obtenerResumenDientes(proc).join(", ")}

                                    </div>

                                    <div
                                        style={{
                                            marginTop:10,
                                            fontWeight:600
                                        }}
                                    >

                                        $

                                        {obtenerSubtotalProcedimiento(proc)

                                            .toLocaleString("es-MX",{

                                                minimumFractionDigits:2,

                                                maximumFractionDigits:2

                                            })}

                                    </div>

                                </div>

                            ))}

                        </div>

                        <div
                            style={{

                                marginTop:40,

                                padding:24,

                                border:"1px solid #d1d5db",

                                borderRadius:12,

                                background:"#f9fafb"

                            }}
                        >

                            <h2
                                style={{

                                    marginTop:0,

                                    marginBottom:20,

                                    fontSize:22

                                }}
                            >

                                Consentimiento informado

                            </h2>

                            <p
                                style={{

                                    lineHeight:1.8,

                                    marginBottom:18,

                                    textAlign:"justify"

                                }}
                            >

                                Declaro que el odontólogo me explicó de forma clara el diagnóstico,
                                el plan de tratamiento propuesto, los beneficios esperados,
                                los posibles riesgos, las alternativas disponibles y los costos
                                correspondientes.

                            </p>

                            <p
                                style={{

                                    lineHeight:1.8,

                                    marginBottom:18,

                                    textAlign:"justify"

                                }}
                            >

                                Tuve oportunidad de hacer todas las preguntas que consideré
                                necesarias y recibí respuesta satisfactoria antes de aceptar este
                                tratamiento.

                            </p>

                            <p
                                style={{

                                    lineHeight:1.8,

                                    marginBottom:18,

                                    textAlign:"justify"

                                }}
                            >

                                Entiendo que durante el tratamiento pueden surgir hallazgos clínicos
                                que hagan necesario modificar o complementar el plan originalmente
                                propuesto.

                            </p>

                            <p
                                style={{

                                    lineHeight:1.8,

                                    marginBottom:0,

                                    textAlign:"justify",

                                    fontWeight:600

                                }}
                            >

                                Después de recibir la información suficiente y comprenderla,
                                acepto voluntariamente el plan de tratamiento descrito en este
                                documento.

                            </p>

                        </div>

                        <div
                            style={{

                                marginTop:40,

                                border:"1px solid #d1d5db",

                                borderRadius:12,

                                padding:24

                            }}
                        >

                            <h2
                                style={{

                                    marginTop:0,

                                    marginBottom:8,

                                    fontSize:22

                                }}
                            >

                                Firma del paciente

                            </h2>

                            <div
                                style={{

                                    color:"#6b7280",

                                    marginBottom:20

                                }}
                            >

                                Firme dentro del recuadro utilizando su dedo,
                                Apple Pencil, mouse o trackpad.

                            </div>

                            <div
                                style={{

                                    border:"2px solid #9ca3af",

                                    borderRadius:12,

                                    overflow:"hidden",

                                    background:"#fff",

                                    marginTop:20

                                }}
                            >

                                <SignatureCanvas

                                    ref={(ref)=>setSignaturePad(ref)}

                                    penColor="black"

                                    canvasProps={{

                                        width:900,

                                        height:250,

                                        style:{

                                            width:"100%",

                                            height:250,

                                            display:"block",

                                            cursor:"crosshair"

                                        }

                                    }}

                                />

                            </div>

                            <div
                                style={{

                                    display:"flex",

                                    justifyContent:"flex-end",

                                    marginTop:15

                                }}
                            >

                                <button

                                    type="button"

                                    onClick={()=>{

                                        signaturePad?.clear();

                                    }}

                                    className="border rounded-xl px-5 py-2"

                                >

                                    Limpiar firma

                                </button>

                            </div>

                            {planes.find(p => p.id === showSignature.id)?.firma && (

                                <div
                                    style={{

                                        marginTop:30,

                                        borderTop:"1px solid #e5e7eb",

                                        paddingTop:20

                                    }}
                                >

                                    <div
                                        style={{

                                            fontWeight:600,

                                            marginBottom:12

                                        }}
                                    >

                                        Firma capturada

                                    </div>

                                    <img

                                        src={planes.find(
                                            p => p.id === showSignature.id
                                        ).firma}

                                        alt="Firma"

                                        style={{

                                            maxWidth:350,

                                            border:"1px solid #d1d5db",

                                            borderRadius:8,

                                            background:"#fff"

                                        }}

                                    />

                                </div>

                            )}

                        </div>

                        <div
                            style={{

                                marginTop:30,

                                display:"flex",

                                justifyContent:"flex-end",

                                gap:12

                            }}
                        >

                            <button

                                onClick={()=>

                                    setShowSignature(null)

                                }

                                className="border rounded-xl px-5 py-3"

                            >

                                Cancelar

                            </button>

                            <button

                                onClick={async () => {

                                    console.log("1");

                                    if (signaturePad?.isEmpty()) {

                                        alert("El paciente debe firmar antes de continuar.");
                                        return;

                                    }

                                    console.log("2");

                                    const firma = signaturePad
                                        .getCanvas()
                                        .toDataURL("image/png");

                                    console.log("3");

                                    const planActualizado = {

                                        ...showSignature,

                                        firma,

                                        estado: "Aceptado",

                                        fechaAceptacion: Date.now(),

                                        cuentaPorCobrarCreada:

                                            showSignature.cuentaPorCobrarCreada || false

                                    };

                                    setPlanes(prev => {

                                        return prev.map(plan =>

                                            plan.id !== showSignature.id

                                                ? plan

                                                : planActualizado

                                        );

                                    });

                                    console.log("5");

                                    setShowSignature(planActualizado);

                                    await guardarPlanFirestore(planActualizado);

                                    if (!planActualizado.cuentaPorCobrarCreada) {

                                        await crearCuentaPorCobrar(
                                            planActualizado
                                        );

                                        planActualizado.cuentaPorCobrarCreada = true;

                                        await guardarPlanFirestore(
                                            planActualizado
                                        );

                                    }

                                    const pdfBlob = generarPDFPlan(

                                        planActualizado

                                    );

                                    const pdfURL = await subirPDFPlan(

                                        planActualizado,

                                        pdfBlob

                                    );

                                    if (pdfURL) {

                                        setPlanes(prev =>

                                            prev.map(plan =>

                                                plan.id === planActualizado.id

                                                    ? {

                                                        ...plan,

                                                        pdfURL

                                                    }

                                                    : plan

                                            )

                                        );

                                    }

                                    console.log("PDF:", pdfURL);

                                    console.log("7");

                                    // Cerrar automáticamente el visor
                                    setShowSignature(null);

                                    alert("Plan de tratamiento aceptado correctamente.");

                                }}

                                className="bg-blue-600 hover:bg-blue-700 text-white rounded-xl px-6 py-3"

                            >

                                Aceptar y continuar

                            </button>

                        </div>

                    </div>

                </div>

            )}

        </div>

    );

}
